import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const OverallApi = createApi({
  reducerPath: "OverallApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["OverallApi"],
  endpoints: (build) => ({
    getAllOverallCounts: build.mutation({
      query: ({ id }) => ({
        url: `/index.php?VALUE=allcount`,
        method: "POST",
        body: { id: id },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["OverallApi"],
    }),

    //     getTeacherById: build.query({
    //       query: ({ id }) => ({
    //         url: `/teachers/${id}`,
    //         method: "GET",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       providesTags: ["OverallApi"],
    //     }),

    //     editTeacher: build.mutation({
    //       query: ({ id, data }) => ({
    //         url: `/teachers/${id}`,
    //         method: "PUT",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["OverallApi"],
    //     }),

    getZoneWise: build.mutation({
      query: (id) => ({
        url: `/master.php?VALUE=zonewise`,
        method: "POST",
        body: {
          zone_id: id,
        },
        headers: {},
      }),
      invalidatesTags: ["OverallApi"],
    }),
    getDistrictWise: build.mutation({
      query: (id) => ({
        url: `/master.php?VALUE=districtwise`,
        method: "POST",
        body: {
          district_id: id,
        },
        headers: {},
      }),
      invalidatesTags: ["OverallApi"],
    }),

    //     deleteTeacher: build.mutation({
    //       query: (id) => ({
    //         url: `/teachers/${id}`,

    //         method: "DELETE",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       invalidatesTags: ["OverallApi"],
    //     }),
  }),
});

export const {
  useGetAllOverallCountsMutation,
  useGetDistrictWiseMutation,
  useGetZoneWiseMutation,
} = OverallApi;
